export enum ModalType {
  Registration = 'registration',
  AutoRegistration = 'auto-registration',
  Login = 'login',
  TermsAndConditions = 'termsAndConditions',
  NewTermsAndConditions = 'newTermsAndConditions',
  ReferralProgram = 'ReferralProgram',
  Deposit = 'deposit',
  EditCurrencies = 'editCurrencies',
  Recovery = 'recovery',
  FullInformation = 'full-information',
  Welcome = 'welcome',
  EasterWonderland = 'easterWonderland',
  TabbarMenu = 'menu',
  MyCurrencies = 'myCurrencies',
  CurrencyRemovalDeclined = 'removal-declined',
  Birthday = 'birthday',
  EditPassword = 'editPassword',
  Withdraw = 'withdraw',
  NetworkModal = 'networkModal',
  ConfirmEmailForNDBModal = 'confirm-email-for-ndb-modal',
  ConfirmedEmailForNDBModal = 'confirmed-email-for-ndb-modal',
  CompleteProfile = 'complete-profile',
  PrivacyPolicy = 'privacy-policy',
  Mission = 'mission',
  MissionComplete = 'mission-complete',
  Lootbox = 'lootbox',
  ConfirmGoogleRegistration = 'confirm-google-registration',
  LotteryWin = 'lotteryWin',
}

export const NON_AUTH_MODALS: ModalType[] = [
  ModalType.Registration,
  ModalType.Login,
  ModalType.AutoRegistration,
];

export const AUTH_MODALS: ModalType[] = [
  ModalType.TermsAndConditions,
  ModalType.NewTermsAndConditions,
  ModalType.ReferralProgram,
  ModalType.Deposit,
  ModalType.EditCurrencies,
  ModalType.FullInformation,
  ModalType.Welcome,
  ModalType.EasterWonderland,
  ModalType.MyCurrencies,
  ModalType.CurrencyRemovalDeclined,
  ModalType.Birthday,
  ModalType.EditPassword,
  ModalType.Withdraw,
  ModalType.NetworkModal,
  ModalType.ConfirmEmailForNDBModal,
  ModalType.ConfirmedEmailForNDBModal,
  ModalType.CompleteProfile,
  ModalType.PrivacyPolicy,
  ModalType.Mission,
  ModalType.ConfirmGoogleRegistration,
];

export const MODAL_QUERY_KEY = 'modal';

export const MODAL_LOADERS: Record<ModalType, () => Promise<any>> = {
  [ModalType.Registration]: () => import('../components/modals/Registration'),
  [ModalType.AutoRegistration]: () =>
    import('../components/modals/AutoRegistration'),
  [ModalType.Login]: () => import('../components/modals/Login'),
  [ModalType.TermsAndConditions]: () =>
    import('../components/modals/TermsAndConditions'),
  [ModalType.Recovery]: () => import('../components/modals/Recovery'),
  [ModalType.FullInformation]: () =>
    import('../components/modals/FullInformation'),
  [ModalType.Welcome]: () => import('../components/modals/Welcome'),
  [ModalType.EditCurrencies]: () =>
    import('../components/modals/EditCurrencies'),
  [ModalType.MyCurrencies]: () => import('../components/modals/MyCurrencies'),
  [ModalType.CurrencyRemovalDeclined]: () =>
    import('../components/modals/CurrencyRemovalDeclined'),
  [ModalType.TabbarMenu]: () =>
    import('../components/general/Tabbar/TabbarMenu'),
  [ModalType.NewTermsAndConditions]: () =>
    import('../components/modals/NewTermsAndConditions'),
  [ModalType.ReferralProgram]: () =>
    import('../components/modals/ReferralProgram'),
  [ModalType.Deposit]: () => import('../components/modals/Deposit'),
  [ModalType.EasterWonderland]: () =>
    import('../components/modals/EasterWonderland'),
  [ModalType.Birthday]: () => import('../components/modals/Birthday'),
  [ModalType.EditPassword]: () => import('../components/modals/EditPassword'),
  [ModalType.Withdraw]: () => import('../components/modals/Withdraw'),
  [ModalType.NetworkModal]: () => import('../components/modals/Network'),
  [ModalType.ConfirmEmailForNDBModal]: () =>
    import('../components/modals/NDB/components/ConfirmEmailForNDB'),
  [ModalType.ConfirmedEmailForNDBModal]: () =>
    import('../components/modals/NDB/components/ConfirmedEmailForNDB'),
  [ModalType.CompleteProfile]: () =>
    import('../components/modals/CompleteProfile'),
  [ModalType.PrivacyPolicy]: () => import('../components/modals/PrivacyPolicy'),
  [ModalType.Mission]: () => import('../components/modals/Mission'),
  [ModalType.MissionComplete]: () =>
    import('../components/modals/CompleteMission'),
  [ModalType.Lootbox]: () => import('../components/modals/LootboxModal'),
  [ModalType.ConfirmGoogleRegistration]: () =>
    import('../components/modals/ConfirmGoogleRegistration'),
  [ModalType.LotteryWin]: () => import('../components/modals/LotteryWin'),
};
